import { ReturnPaymentType, VoidOrderOperationType } from "src/app/@core/constants";
import { InvoiceRequestModel } from "./InvoiceRequestModel";
import { ReturnTransactionContractRequestModel } from "./return-transaction-contract-request-model";

export class ReturnTransactionRequest {
    orderCode: string;
    branchCode: string;
    salesOrgCode: string;
    registerCode: string;
    paymentType: ReturnPaymentType;
    replicateInExternalSystem: boolean = true;
    contractRequestModels: Array<ReturnTransactionContractRequestModel>;
    invoiceDetails: Array<InvoiceRequestModel>;
    voidOrderOperationType: VoidOrderOperationType;


    /**
     *
     */
    constructor() {
        this.orderCode = "";
        this.branchCode = "";
        this.salesOrgCode = "";
        this.registerCode = "";
        this.paymentType = ReturnPaymentType.CASH;
        this.contractRequestModels = [];
        this.invoiceDetails = [];
        this.voidOrderOperationType = VoidOrderOperationType.RETURN;

    }

}